import { Component, Input } from '@angular/core';
import { NgModel } from '@angular/forms';

@Component({
    selector: 'form-input-currency',
    standalone: false,
    templateUrl: './form-input-currency.component.html',
    styleUrls: ['./form-input-currency.component.css'],
})
export class FormInputCurrencyComponent {
    @Input() control!: NgModel;
    @Input() name!: string;
    @Input() help: boolean = false;

    constructor() { }
}
